import React from 'react';
import TopReview from './TopReview/TopReview';

const TopReviews = () => 
{
    return (
        <section className='mt-10 mb-5 p-10'>
            
            <div className="container">
               <TopReview></TopReview>
            </div>
        </section>
    );
};

export default TopReviews;